import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import * as React from 'react';
import {
  IMapPrintImageItemProps,
  MapPrintImageItem,
} from './MapPrintImageItem';

export interface IMapPrintImageSortableItemProps
  extends IMapPrintImageItemProps {
  index: string;
}

export function MapPrintImageSortableItem(
  props: IMapPrintImageSortableItemProps,
) {
  const { index, ...otherProps } = props;
  const { attributes, listeners, setNodeRef, transform, transition, active } =
    useSortable({ id: index });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Translate.toString(transform),
        transition,
      }}
      {...attributes}
      {...listeners}
    >
      <MapPrintImageItem
        {...otherProps}
        isSpaceForDrag={index === active?.id}
      />
    </div>
  );
}
